const PREFIX = "E-LIBRARY";

export class GET_ELIBRARY_INITIAL_DISPLAY {
  public static readonly type = `[${PREFIX}] GET E-LIBRARY INITIAL DISPLAY`;
  constructor(public readonly payload) {}
}

export class GET_ELIBRARY_CONTENT_BY_ID {
  public static readonly type = `[${PREFIX}] GET E-LIBRARY STRUCTURED CONTENT`;
  constructor(public readonly payload) {}
}

export class GET_ELIBRARY_ALL_FOLERS_AND_CONTENT {
  public static readonly type = `[${PREFIX}] GET E-LIBRARY ALL FOLDER AND CONTENT`;
  constructor(public readonly payload) {}
}

export class SET_SELECTED_PRODUCT_DETAIL {
  public static readonly type = `[${PREFIX}] SET SELECTED PRODUCT DETAIL`;
  constructor(public readonly payload) {}
}

export class RESET_SELECTED_PRODUCT_DETAIL {
  public static readonly type = `[${PREFIX}] RESET SELECTED PRODUCT DETAIL`;
  constructor(public readonly payload) {}
}

export class GET_DASHBOARD_ANOUNCEMENTS {
  public static readonly type = `[${PREFIX}] GET DASHBOARD ANNOUNCEMENTS`;
  constructor(public readonly payload) {}
}

export class SEARCH_ELIBRARY_CONTENT {
  public static readonly type = `[${PREFIX}] SEARCH ELIBRARY CONTENT`;
  constructor(public readonly payload) {}
}
export class RESET_SEARCH_ELIBRARY_CONTENT {
  public static readonly type = `[${PREFIX}] RESET SEARCH ELIBRARY CONTENT`;
}

export class GET_RECENT_UPLOAD {
  public static readonly type = `[${PREFIX}] GET RECENT UPLOAD`;
  constructor(public readonly payload) {}
}

export class GET_SINGLE_PRODUCT_DETAILS {
  public static readonly type = `[${PREFIX}] GET SINGLE PRODUCT DETAILS`;
  constructor(public readonly payload) {}
}

export class SET_PRODUCT_BREADCRUM {
  public static readonly type = `[${PREFIX}] SET PRODUCT BREADCRUM`;
  constructor(public readonly payload) {}
}

export class GET_FILTER_LOV {
  public static readonly type = `[${PREFIX}] GET FILTER LOV`;
  constructor(public readonly payload) {}
}
export class SET_SELECTED_ANNOUNCEMENT {
  public static readonly type = `[${PREFIX}] SET SELECTED ANNOUNCEMENT`;
  constructor(public readonly payload) {}
}

export class RESET_ANNOUNCEMENT_SELECTED {
  public static readonly type = `[${PREFIX}] RESET ANNOUNCEMENT SELECTED`;
}

export class RESET_ELIBRARY_CONTENT_AND_RECENT_UPLOAD {
  public static readonly type = `[${PREFIX}] RESET ELIBRARY CONTENT AND RECENT UPLOAD`;
}
